import React from 'react';
import i18next from 'i18next';
import cn from 'classnames';
import { string, bool, func, number, object } from 'prop-types';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';

import { SIDEBAR_ITEMS_ICONS } from '../../constants';

import styles from './styles.module.scss';

function SideBarItem({ isSelected, item, onClick, disabled, quantity, showQuantity, sidebarItem }) {
  const { status } = sidebarItem;
  const [firstStatus] = status;
  const label = i18next.t(`SideBarItem:${firstStatus}`);
  const badgeContent = showQuantity ? `${quantity}` : null;

  const itemIcon = SIDEBAR_ITEMS_ICONS[firstStatus];
  const handleClick = () => {
    onClick(item);
  };
  return (
    <div
      key={item}
      className={cn(
        'middle center',
        styles.item,
        { [styles.sideBarItemSelected]: isSelected },
        { [styles.sideBarItemNotSelected]: !isSelected },
        { [styles.sideBarDisabled]: disabled },
        { column: label },
        { row: !label }
      )}
      {...(!disabled && { onClick: handleClick })}>
      <Badge
        badgeContent={badgeContent}
        sx={{
          '& .MuiBadge-badge': {
            color: 'white',
            backgroundColor: '#ED6C02'
          }
        }}>
        {showQuantity && (
          <img
            className={cn(styles.sideBarIcon, styles.sideBarIconBadge, {
              [styles.sideBarIconSelected]: isSelected
            })}
            src={isSelected ? itemIcon.selected : itemIcon.disabled}
            alt={i18next.t(`SideBarItem:${firstStatus}`)}
          />
        )}
      </Badge>
      {!showQuantity && (
        <img
          className={cn(styles.sideBarIcon, {
            [styles.sideBarIconSelected]: isSelected
          })}
          src={isSelected ? itemIcon.selected : itemIcon.disabled}
          alt={i18next.t(`SideBarItem:${firstStatus}`)}
        />
      )}

      <Typography
        color="white"
        fontSize={12}
        fontWeight={({ typography: { fontWeightBold } }) => fontWeightBold}
        sx={{ marginTop: 1 }}>
        {label}
      </Typography>
    </div>
  );
}

SideBarItem.propTypes = {
  disabled: bool.isRequired,
  item: string.isRequired,
  onClick: func.isRequired,
  isSelected: bool,
  label: string,
  quantity: number,
  showQuantity: bool,
  sidebarItem: object.isRequired
};

SideBarItem.defaultProps = {
  quantity: 0,
  showQuantity: false
};
export default SideBarItem;
